import { render, staticRenderFns } from "./FinishAnim.vue?vue&type=template&id=1a1d4228&scoped=true"
import script from "./FinishAnim.vue?vue&type=script&lang=js"
export * from "./FinishAnim.vue?vue&type=script&lang=js"
import style0 from "./FinishAnim.vue?vue&type=style&index=0&id=1a1d4228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1d4228",
  null
  
)

export default component.exports